/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'userDevices';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'userDevice';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'userDevice';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'userDevices';

/** Default OData sort when the user clears column sorting. */
export const DEFAULT_ORDER_BY = 'lastLogin desc';
